import { render, staticRenderFns } from "./XmAccountManager.vue?vue&type=template&id=f10953c4&scoped=true"
import script from "./XmAccountManager.vue?vue&type=script&lang=js"
export * from "./XmAccountManager.vue?vue&type=script&lang=js"
import style0 from "./XmAccountManager.vue?vue&type=style&index=0&id=f10953c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10953c4",
  null
  
)

export default component.exports